import './Header.css';

const Header = () => {
  return (
    <header>
      <h3>SkyCast</h3>
    </header>
  );
};

export default Header;
